import React from "react";
import Feature from "../../components/feature/Feature";
import "./whatGPT3.css";

const WhatGPT3 = () => (
  <div className="gpt3__whatgpt3 section__margin" id="wgpt3">
    <div className="gpt3__whatgpt3-feature">
      <Feature
        title="Your AI Research Writing Assistant"
        text="WriteAI is built for writers who need more than a blank page. Whether you're writing a research paper, a business report, or a technical document, WriteAI helps you find sources, organise references, and stay on track — without switching between a dozen tools."
      />
    </div>
    <div className="gpt3__whatgpt3-heading">
      <h1 className="gradient__text">Everything you need to write with confidence</h1>
      <p>How it works</p>
    </div>
    <div className="gpt3__whatgpt3-container">
      <Feature
        title="Research While You Write"
        text="Add sources and manage references directly inside your document. No more jumping between tabs — your research stays with your writing."
      />
      <Feature
        title="Smart Citation Formatting"
        text="Insert inline citations and copy full APA-formatted references with one click. WriteAI handles the formatting so you can focus on the content."
      />
      <Feature
        title="Tailored to Your Paper Type"
        text="Choose from Research Paper, Business Report, Literature Review, Case Study, or Technical Report. Each type comes with relevant structure and AI guidance built in."
      />
    </div>
  </div>
);

export default WhatGPT3;
